import { normalize } from "normalizr";
import { all, call, put, takeLatest } from "redux-saga/effects";

import {
    FAQ_INDEX_FETCH_TRIGGER,
    FaqIndexFetchNormalizedResponse,
    FaqIndexFetchTriggerAction,
    faqIndexFetchApi,
} from "@/mk2/apps/faq/containers/FaqIndex/FaqIndex.actions";
import { ArticleLinkEntity, ArticleLinkSchema } from "@/mk2/apps/faq/schemas";
import { XHRAction, XHRGetError, handleXHRGetErrorSaga, normalizeError } from "@/mk2/helpers/api";
import { getLogger } from "@/mk2/logger";
import { WikiArticleEntity, WikiArticleSchema } from "@/mk2/schemas";
import { faq_api_index_url } from "@/mk/urls/functions";

const logger = getLogger("faq/FaqIndex.sagas");

interface ApiResponseArticle {
    body: {
        article: WikiArticleEntity;
        articles: ArticleLinkEntity[];
    };
}

function* fetchArticle({ articleSlug, query, xhr }: FaqIndexFetchTriggerAction & XHRAction) {
    yield put(faqIndexFetchApi.request(articleSlug, query));

    try {
        const response: ApiResponseArticle = yield call(() =>
            xhr.get(faq_api_index_url(), { articleSlug, q: query }),
        );

        const normalizedResponse: FaqIndexFetchNormalizedResponse = normalize(response.body, {
            article: WikiArticleSchema,
            articles: [ArticleLinkSchema],
        });
        yield put(faqIndexFetchApi.success(articleSlug, query, normalizedResponse));
    } catch (error) {
        yield handleXHRGetErrorSaga(error as XHRGetError, logger);
        yield put(faqIndexFetchApi.failure(articleSlug, query, normalizeError(error)));
    }
}

export default function* root() {
    yield all([takeLatest(FAQ_INDEX_FETCH_TRIGGER, fetchArticle)]);
}
